export enum AddOnType {
  CUSTOM_EXTRACTION = 'CUSTOM_EXTRACTION',
  MTN_MODEL_DATA = 'MTN_MODEL_DATA',
  PLANNED_GROCERY = 'PLANNED_GROCERY'
}
